




























import Application from '@/datatypes/application';
import ApplicationService from '@/services/application/application-service';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import Vue from 'vue';

export default Vue.extend({
  data: () => ({
    applications: new Array<Application>(),
    hasNext: true,
    errorMessage: '',
    applicationSearch: {
      term: '' as string | (string | null)[],
    },
    nextPointer: undefined as string | undefined,
    applicationService: new ApplicationService(),
    totalCount: 0,
  }),

  components: {
    SnackbarMessageHandler,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  methods: {
    routeChanged() {
      this.getApplications();
    },

    getQueryOptions() {
      return {
        term: this.applicationSearch.term,
        next: this.nextPointer,
      };
    },

    concatApplicationResponse(data: Application[]) {
      this.applications = this.applications.concat(data);
    },

    getApplications() {
      this.applicationService.getPendingApplications(this.getQueryOptions()).then((response) => {
        this.concatApplicationResponse(response.data.map(
          (data) => new Application(camelcaseKeysDeep(data)),
        ));

        if (this.applications.length === 0) {
          this.errorMessage = 'No applications found.';
        }

        if (response.headers.total_count) {
          this.totalCount = response.headers.total_count;
        } else {
          this.totalCount = 0;
        }

        if (response.headers.next) {
          this.nextPointer = response.headers.next;
        } else {
          this.nextPointer = undefined;
          this.hasNext = false;
        }

        if (response.data.length === 0) {
          this.hasNext = false;
        }
      });
    },

    requestNextPage() {
      this.getApplications();
    },

    searchApplications() {
      this.applications = [];
      this.nextPointer = undefined;
      this.getApplications();
    },
  },
});
